import { ReactNode } from 'react';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

interface IProps {
  className?: string;
  scrollClassName?: string;
  scrollSize?: 'small' | 'normal';
  children?: ReactNode;
}

const ModalContent = ({ className, scrollClassName, scrollSize = 'normal', children }: IProps): JSX.Element => {
  return (
    <ScrollableBlock
      showScrollbar
      scrollbarSize={scrollSize}
      className={`custom-modal__main mr-1 ${className || ''}`}
      scrollClassName={`pt-6 px-8 ${scrollClassName || ''}`}>
      {children}
    </ScrollableBlock>
  );
};

export default ModalContent;
